import { Component, OnInit, Inject, Output, EventEmitter, Input } from "@angular/core";
import { UMPCategory, Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { SaveService } from '../../../../../services/save.service';
import { ActivatedRoute, Params } from '@angular/router';
import { SpinnerOverlayService } from '../../../../../services/spinner-overlay.service';
import { ToastrService } from 'ngx-toastr';

interface UMPMersyKPIGroupFunctionNode {
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: UMPMersyKPIGroupFunctionNode;


    id: string,
    text: string,
    type: string,
    icon: string,
    state: any,
    securityStatus: number,
    isAssigned: boolean,
    isTenantNode: boolean,
    canAssign: boolean,
    canUnassign: string,
    children: UMPMersyKPIGroupFunctionNode[]

}

@Component({
    selector: "mersykpigroupfunction",
    templateUrl: './mersykpigroupfunction.component.html',
    styleUrls: ['./mersykpigroupfunction.component.less', '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class MersyKPIGroupFunction implements OnInit {
    @Input() public groupmgmtcallback: Function | undefined;
    @Output() secondaryTenUpdate = new EventEmitter<{ selTen: string[], checked: boolean }>();

    userId = '';
    public TREE_DATA: UMPMersyKPIGroupFunctionNode[] = [];/*** */

    public selectedNodes: string[] = [];
    public unSelectedNodes: string[] = [];

    public treeControl: NestedTreeControl<UMPMersyKPIGroupFunctionNode>;
    public dataSource = new MatTreeNestedDataSource<UMPMersyKPIGroupFunctionNode>();

    public searchString = '';
    public showOnlySelected = false;

    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    showData: boolean = false;

    isCallSucceed: number = 0;

    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.MersyKPIGroupFunction
    }

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private saveService: SaveService,
        private route: ActivatedRoute,
        private spinnerOverlayService: SpinnerOverlayService,
        private toastrService: ToastrService) {

        this.treeControl = new NestedTreeControl<UMPMersyKPIGroupFunctionNode>((node) => node.children)
    }

    ngOnInit() {
        this.route.params.subscribe(
            (params: Params) => {
                this.hideData();
            });
    }

    ngOnChanges() {
        if (this.userId !== '')
            this.functGetUserMersyKPI();
    }

    resetAll() {
        this.userId = '';
        this.showData = true;
        this.treeControl = new NestedTreeControl<UMPMersyKPIGroupFunctionNode>((node) => node.children);
        this.dataSource = new MatTreeNestedDataSource<UMPMersyKPIGroupFunctionNode>();
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.functGetUserMersyKPI();
    }

    functGetUserMersyKPI() {
        Utils.httpGetUserMersyKPIGroupFunction(
            this.http
            , this.baseUrl
            , this.userId
            , this
            , (tthis: MersyKPIGroupFunction, data: any) => {

                tthis.TREE_DATA = [data.rootTenantNodes];

                tthis.treeControl.dataNodes = tthis.TREE_DATA;
                tthis.dataSource.data = tthis.TREE_DATA;
                Object.keys(tthis.dataSource.data).forEach((key) => {
                    tthis.setParent(tthis.dataSource.data[key], undefined);
                }
                )
                tthis.preselect();


            });
    }

    public hideLeafNode(node: UMPMersyKPIGroupFunctionNode): boolean {
        return new RegExp(this.searchString, 'i').test(node.text) === false;
    }

    public itemToggle(checked: boolean, node: UMPMersyKPIGroupFunctionNode, manualUpdate: boolean = false) {

        if (manualUpdate) {
            this.saveService.addListener(this)
            this.saveService.showSaveButton();
            this.searchTenant(checked, node);
        }
        node.selected = checked;
        if (node.children && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);

        }
        if (node.children) {
            this.itemDisable(checked, node);
        }
        if (manualUpdate) {
            if (checked) {
                this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.id)
                if (this.unSelectedNodes.find(e => e === node.id))
                    this.data.SelectedBranches.push(node.id)
            }
            else {
                this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.id)
                if (node.canUnassign)
                    this.data.UnselectedBranches.push(node.id)
            }
        }
        this.checkAllParents(node);
    }

    private searchTenant(checked: boolean, node: UMPMersyKPIGroupFunctionNode) {
        if (node.isTenantNode) {
            this.secondaryTenUpdate.emit({ selTen: [this.extractText(node.text)], checked });
        }
        else {
            this.searchTenantInDesc(checked, node);
        }
    }

    private itemUnselect(node: UMPMersyKPIGroupFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.selected ? this.data.UnselectedBranches.push(node.id) : null; node.indeterminate = false; node.selected = false; });
    }

    private itemDisable(checked: boolean, node: UMPMersyKPIGroupFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => node.disabled = checked);
    }

    private checkAllParents(node: UMPMersyKPIGroupFunctionNode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    extractText = (input: string) =>
        input.replace(/\s+/g, '').split('(')[0];

    private searchTenantInDesc(checked: boolean, node: UMPMersyKPIGroupFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        var tenNode = descendants.filter(node => node.isTenantNode);
        if (tenNode.length > 0) {
            var selTen = tenNode.map((node) => this.extractText(node.text))
            this.secondaryTenUpdate.emit({ selTen, checked });
        }
        else {
            this.searchTenantInParent(checked, node);
        }
    }

    private searchTenantInParent(checked: boolean, node: UMPMersyKPIGroupFunctionNode) {
        if (node.parent) {
            node.parent.isTenantNode ? (this.secondaryTenUpdate.emit({ selTen: [this.extractText(node.parent.text)], checked })) : null;
            this.searchTenantInParent(checked, node.parent);
        }
    }

    public hideParentNode(node: UMPMersyKPIGroupFunctionNode): boolean {
        if (
            !this.searchString ||
            node.text.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        ) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.text
                        .toLowerCase()
                        .indexOf(this.searchString.toLowerCase()) !== -1
            )
        ) {
            return false
        }

        return true
    }

    public hasChild = (_: number, node: UMPMersyKPIGroupFunctionNode) =>
        !!node.children && node.children.length > 0

    private setParent(node: UMPMersyKPIGroupFunctionNode, parent: UMPMersyKPIGroupFunctionNode | undefined) {
        node.parent = parent;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private preselect() {
        this.unSelectedNodes = [] as string[];
        for (let i = 0; i < this.treeControl.dataNodes.length; i++) {

            if (this.treeControl.dataNodes[i].canUnassign) {
                this.itemToggle(true, this.treeControl.dataNodes[i]);
            }
            else
                this.unSelectedNodes.push(this.treeControl.dataNodes[i].id);
            if (this.treeControl.dataNodes[i].children) {
                const alldecendents = this.treeControl.getDescendants(this.treeControl.dataNodes[i]);
                for (let j = 0; j < alldecendents.length; j++) {
                    if (alldecendents[j].canUnassign) {
                        this.itemToggle(true, alldecendents[j]);
                    }
                    else
                        this.unSelectedNodes.push(alldecendents[j].id);
                }
            }

        }
    }

    onSave() {
        if (this.data.SelectedBranches.length > 0 || this.data.UnselectedBranches.length > 0) {
            this.spinnerOverlayService.setFalseskipInterceptor()
            Utils.httpPostTreeGroupsByType(
                this.http
                , this.baseUrl
                , this.data
                , this.userId
                , this
                , function (tthis: MersyKPIGroupFunction, data: any) {
                    tthis.data.SelectedBranches = []
                    tthis.data.UnselectedBranches = []
                    tthis.spinnerOverlayService.setTrueskipInterceptor()
                    tthis.funcNotify();
                    tthis.functGetUserMersyKPI();
                    if (tthis.groupmgmtcallback)
                        tthis.groupmgmtcallback(data);
                }
            )
        }
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Update Mersy KPI Group Function request sent successfully !', 'Update Mersy KPI Group Function Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Update Mersy KPI Group Function request not sent successfully !', 'Update Mersy KPI Group Function Request!');
        }
    }

    hideData() {
        this.showData = false;
        this.TREE_DATA = [];
        this.treeControl.dataNodes = [];
        this.dataSource.data = [];
    }
}